import {  Select } from "antd";
import React, { useEffect, useState } from "react";
import { AssetStore } from "../../../assets/AssetsStore";
import styles from "./index.module.scss";

const { Option } = Select;

function Searchbox({ options, onSelect, onSearch, value, readOnly }) {
  let [searchvalue, setSearchValue] = useState(null);

  let handleOnChange = (e) => {
    setSearchValue(e);
    onSearch(e);
  };


  useEffect(() => {
    setSearchValue(null)
  }, [value])




  return (
    <div className={styles.autocomplete_wrap}>
      <Select
        disabled={readOnly?true:false}
        value={searchvalue}
        showSearch
        placeholder="Search"
        className={styles.search_box_container}
        suffixIcon={<img src={AssetStore.managePrescription.search} alt="" />}
        getPopupContainer={(trigger) => trigger.parentNode}
        style={{
          minWidth: "437px !important",
        }}
          filterOption={(inputValue, option) =>
           
            option.value.toLowerCase().startsWith(inputValue?.toLowerCase())
         }
        onChange={handleOnChange}
        onSelect={onSelect}
        onSearch={handleOnChange}
      >
         {options.map((p, key) => <Option key={p.value+key} value={p.value}>{p.label}</Option>)}
       
       
      </Select>
    </div>
  );
}

export default Searchbox;
